import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { ReploComponent } from "replo-runtime/store/components/ReploComponent";

export const BundleSummary: React.FC<RenderComponentProps> = ({
  component,
  context,
  componentAttributes,
}) => {
  return (
    <div
      style={{
        position: "relative",
        borderLeftColor: "#CBD5E1FF",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
      }}
    >
      <div
        {...componentAttributes}
        style={{
          boxSizing: "border-box",
          gap: "16px",
          ...componentAttributes.style,
        }}
      >
        {component.children?.map((child) => (
          <ReploComponent key={child.id} context={context} component={child} />
        ))}
      </div>
    </div>
  );
};
